import { VueController } from 'util/vue_controller'

// Connects to data-controller="distributor-volume-submissions"
export default class extends VueController {
  static vueComponent = 'distributor-volume-submissions'

  static targets = ['tableBody', 'confirmation']

  static values = {
    chains: Array,
    submissions: Array,
    pricingPrograms: Array,
    team: String
  }

  get props () {
    return {
      chains: this.chainsValue,
      submissions: this.submissionsValue,
      pricingPrograms: this.pricingProgramsValue,
      team: this.teamValue
    }
  }

  get vueTarget () {
    return this.tableBodyTarget
  }
}
